(function () {
  "use strict";

  angular.module("marketPlace.items").controller("ItemsAddController", ItemsAddController);

  ItemsAddController.$inject = [
    "$scope",
    "$uibModalInstance",
    "$state",
    "$transition$",
    "user",
    "organisations",
    "$log",
    "CountryName",
    "AppConfig",
    "Item",
    "ItemForm",
    "writableNiches",
    "_",
    "PermAuthorization",
    "PermPermissionMap",
    "countries",
    "Preview",
    "currencies",
    "settings",
    "toastr",
    "GroupCategories",
    "SITE_NAME",
    "modalTitle",
  ];

  function ItemsAddController(
    $scope,
    $uibModalInstance,
    $state,
    $transition$,
    user,
    organisations,
    $log,
    CountryName,
    AppConfig,
    Item,
    ItemForm,
    writableNiches,
    _,
    PermAuthorization,
    PermPermissionMap,
    countries,
    Preview,
    currencies,
    settings,
    toastr,
    GroupCategories,
    SITE_NAME,
    modalTitle
  ) {
    const vm = this;
    const stateParams = $transition$.params();

    vm.saving = false;
    vm.duplicate = false;
    vm.errors = {};
    vm.uploadProgressPercentage = 0;
    vm.videoUrl = {
      url: "",
      media_type: "video",
    };

    // pre-resolved dependencies
    vm.user = user;
    vm.organisation = organisations.length > 0 ? organisations[0] : null;
    vm.niches = writableNiches;
    vm.countries = countries;
    vm.currency_options = currencies;
    vm.siteName = SITE_NAME;
    vm.modalTitle = modalTitle;

    vm.imageAreaType = settings.ITEM_IMAGE_SHAPE || "square";
    vm.gallery_for_sale = false;

    vm.galleries = {}; // this has to be defined or ui-select doesn't update when a section is selected

    // gallery is populated when a gallery is selected
    vm.niche = null;
    vm.gallery = null;

    vm.itemExternalImageLimit = AppConfig.itemExternalImageLimit;
    vm.categoryLabel = AppConfig.categoryLabel;

    vm.accept = "image/*";
    vm.pattern = "image/*";
    vm.price = 0;
    vm.paymentAmounts = [];

    const changeHandlers = ItemForm.getChangeHandlers(vm);

    // item form methods
    vm.save = save;
    vm.saveAndClose = saveAndClose;
    vm.getCountry = getCountry;
    vm.openPreview = Preview.open;
    vm.addVideo = addVideo;
    vm.getCategories = ItemForm.getCategories;
    vm.isRealisation = ItemForm.isRealisation;
    vm.setNiche = changeHandlers.setNiche;
    vm.setSection = changeHandlers.setSection;
    vm.setGallery = changeHandlers.setGallery;
    vm.setCaption = changeHandlers.setCaption;
    vm.setCaptionOption = changeHandlers.setCaptionOption;
    vm.showField = showField;
    vm.groupPreferredCountries = groupPreferredCountries;
    vm.getPriceString = ItemForm.getPriceString;
    vm.next = next;
    vm.back = back;
    vm.create = create;
    vm.saveWithPayment = saveWithPayment;
    vm.onPaymentError = onPaymentError;
    vm.changePublishAfter = angular.bind(vm, ItemForm.changePublishAfter);
    vm.clearPublishAfter = angular.bind(vm, ItemForm.clearPublishAfter);
    vm.setPrimaryImage = setPrimaryImage;
    vm.deleteImage = deleteImage;
    vm.showPayment = showPayment;

    vm.croppedDoubleWidth = null;
    vm.uploadDoubleFile = null;

    // forms
    vm.itemForm = {};
    vm.itemForm.form = {};

    // Date controls
    vm.dateOptions = {
      formatYear: "yy",
      startingDay: 1,
    };
    vm.dateControlsState = {
      dateFromOpen: false,
      dateToOpen: false,
      realisationDateOpen: false,
    };
    vm.publishDateOptions = {
      minDate: new Date(),
    };

    vm.userCanAddURL = false;
    vm.userCanAddPrice = false;
    vm.userCanAddVideoURL = false;

    activate();
    function activate() {
      if (!vm.user) {
        $state.go("register", { goTo: "items.add" }, { notify: false });
      }

      if (stateParams.id) {
        ItemForm.getItem(stateParams.id).then(function (item) {
          $log.debug("ITEM", item);
          vm.item = ItemForm.copyItem(item);
          ItemForm.initializeVideoUrl(vm);
          changeHandlers.setCaption();
          changeHandlers.setCaptionOption();
          init();
        });
      } else {
        vm.item = ItemForm.newItem(vm.user);
        vm.item.item_layout = "standard";
        if (vm.niches._order.length === 1) {
          vm.item.niche_option = vm.niches._order[0];
          changeHandlers.setNiche();
        }

        if (stateParams.section) {
          $log.debug(stateParams, writableNiches);
          vm.item.section_option = stateParams.section;
          changeHandlers.setSection();
        }
        init();
      }
    }

    function init() {
      PermAuthorization.authorizeByPermissionMap(new PermPermissionMap({ only: ["add_item_video"] }))
        .then(function () {
          vm.accept = "image/*,video/*,video/mp4";
          vm.pattern = "image/*,video/*";
        })
        .catch(angular.noop);

      PermAuthorization.authorizeByPermissionMap(new PermPermissionMap({ only: ["add_item_url"] }))
        .then(function () {
          vm.userCanAddURL = true;
        })
        .catch(angular.noop);

      PermAuthorization.authorizeByPermissionMap(new PermPermissionMap({ only: ["add_item_price"] }))
        .then(function () {
          vm.userCanAddPrice = true;
        })
        .catch(angular.noop);

      PermAuthorization.authorizeByPermissionMap(new PermPermissionMap({ only: ["add_item_video_url"] }))
        .then(function () {
          vm.userCanAddVideoURL = true;
        })
        .catch(angular.noop);

      PermAuthorization.authorizeByPermissionMap(new PermPermissionMap({ only: ["add_photo_for_sale"] }))
        .then(function () {
          vm.userCanMakePhotoForSale = true;
        })
        .catch(angular.noop);

      vm.imageProducts = Item.imageProducts();

      vm.groupCats = GroupCategories.query();
    }

    // watchers
    $scope.$watch("vm.files", function () {
      ItemForm.upload(vm, $scope, vm.files);
    });

    function setPrimaryImage(index) {
      for (let i = 0; i < vm.item.external_images.length; i++) {
        vm.item.external_images[i].primary = i === index;
      }
    }

    function deleteImage(index) {
      vm.item.external_images.splice(index, 1);
    }

    // Looks like typeahead bug - model field is not
    // being cleared when the input is empty
    $scope.$watch("vm.item.country_name", function (newValue) {
      if (newValue === "") {
        delete vm.item.country_name;
      }
    });

    function getCountry(val) {
      return CountryName.all({ q: val });
    }

    function save(form, files, close = false) {
      $log.debug("saving");
      $log.debug("form: " + form);
      $log.debug("files: " + files);

      $scope.$broadcast("show-errors-check-validity");

      if (form.$invalid) {
        $log.debug("Form invalid");
        $log.debug(vm.item, form.$error);
        return;
      }

      vm.saving = true;

      $log.debug("saving item", vm.item);
      vm.item.$save(
        function (resp: any, headers: any, status: number) {
          $scope.$broadcast("show-errors-reset");
          $log.debug(status);
          if (status === 202) {
            toastr.warning("Item submitted for moderation");
          } else {
            toastr.success("Item added");
          }

          if (close) {
            $uibModalInstance.close(true);
          } else {
            form.$setPristine();
            vm.item = ItemForm.copyItem(vm.item);
            ItemForm.initializeVideoUrl(vm);
            vm.setCaption();
            changeHandlers.setCaptionOption();
            vm.paying = false;
            padCategories();
            vm.saving = false;
            vm.uploadFile = null;
          }
        },
        function (resp) {
          $log.debug("Error saving item");

          if (resp.data && resp.status === 402) {
            // show payment screen
            vm.paying = true;
            $log.debug(resp.data);
            toastr.error("Sorry there was a problem with your payment: " + resp.data.detail);
          } else if (resp.data && resp.status !== 500) {
            angular.forEach(resp.data, function (errors, field) {
              $log.debug(field + " : " + errors);
              try {
                form[field].$setValidity("server", false);
                if (angular.isArray(errors)) {
                  vm.errors[field] = errors.join(", ");
                } else {
                  angular.forEach(errors, function (nested_errors) {
                    vm.errors[field] = nested_errors.join(", ");
                  });
                }
              } catch (e) {
                $log.error(resp.status + ": " + resp.statusText);
                if (angular.isArray(errors)) {
                  errors = errors.join(", ");
                  vm.errors.non_field_errors = errors;
                } else if (angular.isObject(errors)) {
                  angular.forEach(errors, function (nested_errors, field) {
                    try {
                      form[field].$setValidity("server", false);
                      if (angular.isArray(nested_errors)) {
                        vm.errors[field] = nested_errors.join(", ");
                      } else {
                        angular.forEach(nested_errors, function (more_nested_errors) {
                          vm.errors[field] = more_nested_errors.join(", ");
                        });
                      }
                    } catch (e) {
                      vm.errors.non_field_errors = errors;
                    }
                  });
                } else {
                  vm.errors.non_field_errors = errors;
                }
              }
            });
            vm.paying = false;
          } else {
            $log.error(resp.status + ": " + resp.statusText);
            toastr.error("Sorry there was a problem with your new listing, please try again");
            vm.paying = false;
          }
          $scope.$broadcast("show-errors-check-validity");
          padCategories();
          vm.saving = false;
          vm.uploadFile = null;
        }
      );
    }

    // TODO
    function padCategories() {
      while (vm.user.categories.length < 2) {
        vm.user.categories.push({ name: "" });
      }
    }

    function saveAndClose(form, files) {
      save(form, files, true);
    }

    function addVideo() {
      vm.item.external_images = _.dropWhile(vm.item.external_images, {
        media_type: "video",
      });
      if (vm.videoUrl.url) {
        const videoObject = ItemForm.parseVideo(vm.videoUrl.url);
        vm.videoUrl = { ...vm.videoUrl, ...videoObject };
        console.debug(vm.videoUrl);
        if (vm.videoUrl.id) {
          vm.item.external_images.push(vm.videoUrl);
        } else {
          vm.itemForm.form.video_url.$setValidity("url", false);
          $scope.$broadcast("show-errors-check-validity");
        }
      }
    }

    function groupPreferredCountries(country) {
      if (country.priority) {
        return undefined;
      }
      return "--";
    }

    function getPaymentAmounts() {
      const amounts = [];
      if (vm.listing && vm.listing.amount > 0) {
        amounts.push({
          amount: vm.listing.amount,
          name: "Listing: " + vm.listing.name,
          feesIncluded: true,
        });
      }

      $log.debug(amounts);

      return amounts;
    }

    function next(form, files, duplicate = false) {
      if (!vm.item.external_images || vm.item.external_images.length === 0) {
        form.external_images.$setValidity("required", false);
      } else {
        form.external_images.$setValidity("required", true);
      }

      $scope.$broadcast("show-errors-check-validity");

      if (form.$invalid) {
        $log.debug("Form invalid");
        $log.debug(vm.item, form.$error);
        return;
      }

      vm.itemForm.form = form;
      vm.files = files;

      if (!isPaymentRequired()) {
        return create(duplicate);
      }

      vm.paying = true;
      vm.paymentAmounts = getPaymentAmounts();
      vm.listingPrice = vm.listing && vm.listing.amount ? vm.listing.amount : 0;
    }

    function back() {
      vm.paying = false;
    }

    function saveWithPayment(payment) {
      if (payment) {
        vm.item.payment = payment;
      }
      save(vm.itemForm.form, vm.files, !vm.duplicate);
    }

    function onPaymentError(error) {
      toastr.error(error);
      vm.saving = false;
    }

    function create(duplicate = false) {
      vm.saving = true; // triggers payment directive save
      vm.duplicate = duplicate;

      if (!isPaymentRequired()) {
        save(vm.itemForm.form, vm.files, !vm.duplicate);
      }

      // payment directive will eventually call saveWithPayment
    }

    function isPaymentRequired() {
      return vm.listing.amount > 0;
    }

    function showField(field: string) {
      $log.debug(vm.item.caption_option, vm.captions);
      if (vm.item.caption_option && vm.caption_index) {
        $log.debug(vm.captions[vm.caption_index]);
        return vm.item.caption_option && vm.captions && vm.captions[vm.caption_index].hide.indexOf(field) === -1;
      }
      return false;
    }

    function showPayment() {
      // Always show payment info when creating an item
      return true;
    }
  }
})();
